import * as classnames from 'classnames/bind'
import * as React from 'react'

// import { dispatch } from '../../store'
import { connect } from 'react-redux'
import { RootState } from '../../store'
import itemStyles from './lecture-item.scss'
import TeacherComponent from './lecture-teacher-component'
import styles from './lecture-teachers.scss'


const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean,
  lectureId: string,
  lecture: ILecture
}
interface IState {
  speakers: string[],
  speakerInfo: any
}

class LectureTeachers extends React.Component<IProps, IState> {
  public state: IState = {
    speakers: [],
    speakerInfo: []
  }

  public render() {
    const { lecture } = this.props
    const { speakerIds, speakerInfo } = lecture
    return (
      <div className={cx('section', { teacher_section: true })}>
        <div className={cx('section_header')}>講師介紹</div>
        <div className={cx('section_content')}>
          {
            speakerIds.map((speakerId) => (
              <TeacherComponent key={speakerId} userId={speakerId} information={speakerInfo[speakerId]}/>
              )
            )
          }
        </div>
      </div>
    )
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(LectureTeachers)


// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-teachers.tsx